function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M41.5,23.2l.5.1c7.7,1,13.7,7,14.6,14.6l.1.5h12v-.5c-1.1-14.2-12.4-25.5-26.6-26.6h-.5v-2.8c0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6,1.6v2.8h3.1v11.9Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M38.5,56.8l-.5-.1c-7.7-1-13.7-7-14.6-14.6l-.1-.5h-12v.5c1.1,14.2,12.4,25.5,26.6,26.6h.5v-11.5l.1-.4Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M38.4,71.5c0,.9.7,1.6,1.6,1.6s1.6-.7,1.6-1.6v-2.8h-3.2v2.8Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M8.5,38.4c-.9,0-1.6.7-1.6,1.6s.7,1.6,1.6,1.6h2.8v-3.2h-2.8Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M45.6,40c0-.9.7-1.6,1.6-1.6h6.4l-.1-.7c-1-5.7-5.5-10.2-11.2-11.2l-.7-.1v6.4c0,.9-.7,1.6-1.6,1.6s-1.6-.7-1.6-1.6v-6.4l-.7.1c-4.7.7-8.6,3.9-10.4,8.3-.3.8-1.2,1.2-2,.9-.8-.3-1.2-1.2-.9-2,2.3-5.6,7.5-9.6,13.5-10.3l.5-.1v-12h-.5c-14.2,1.1-25.5,12.4-26.6,26.6v.5h21.5c.9,0,1.6.7,1.6,1.6s-.7,1.6-1.6,1.6h-6.4l.1.7c1,5.7,5.5,10.2,11.2,11.2l.7.1v-6.4c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6v6.4l.7-.1c4.7-.7,8.6-3.9,10.4-8.3.3-.8,1.2-1.2,2-.9.8.3,1.2,1.2.9,2-2.3,5.6-7.5,9.6-13.5,10.3l-.5.1v12h.5c14.2-1.1,25.5-12.4,26.6-26.6v-.5h-21.5c-.9,0-1.6-.7-1.6-1.6ZM41.7,41.7c-.9.9-2.4.9-3.3,0-.5-.5-.7-1.1-.7-1.7v-.1c0-1.3,1.1-2.2,2.3-2.2.6,0,1.2.2,1.7.7.9.9.9,2.4,0,3.3Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M71.5,38.4h-2.8v3.2h2.8c.9,0,1.6-.7,1.6-1.6s-.7-1.6-1.6-1.6Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default __webpack_public_path__ + "static/media/Shooting-active.0697c3a8.svg";
export { SvgComponent as ReactComponent };